import api from '@/api'
const submit = async (buttonData, args = {}) => {
  const { data, params } = args
  const method = api[buttonData.method]
  try {
    const response = await method(buttonData.uri, data, params)
    return response
  } catch (error) {
    throw error
  }
}

const apicall = async (buttonData, args = {}) => {
  //
}

const goto = async (buttonData, args = {}) => {
  //
}

export default {
  submit,
  apicall,
  goto
}
